import React from "react"
import "../../assets/scss/styles.scss"
import question from "../../assets/img/question.svg"

export const Associaion_Certification = ({requestedContractor}) => {
    const certifications = requestedContractor.contractor.ppn_business_certifications?.split(';').filter((x) => !!x)
    const associations = requestedContractor.contractor.ppn_trade_affiliations?.split(';').filter((x) => !!x)

    return (
        <div className="active-fac-tab">
            <div className="tab-content-title">
                <h4 className="tab-content-title-text">
                  Associations and Certifications
                </h4>
            </div>
            <ul className="contractor-info-list"> 
              {requestedContractor.contractor.ppn_business_certifications ? certifications?.map((s, i) => <li key={i}>{s}</li>) : ''} 
              {requestedContractor.contractor.ppn_trade_affiliations ? associations?.map((s, i) => <li key={i}>{s}</li>) : ''} 
            </ul>
            {(!requestedContractor.contractor.ppn_business_certifications && !requestedContractor.contractor.ppn_trade_affiliations) && <p className="default-no-assoc-text"> At this time the member has not shared trade associations and has not identified with a Diversity & Inclusion business certification. </p>}
        </div>
    )
}